/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useContext, useEffect, useState } from 'react';
import { validateObject } from '../Shared/validateObject';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../componentstyles/globalstyles';
import DynamicGridRA from '../InventoryTabs/AgreementHistory/dynamicGrids/dynamicGridRA';
import DynamicGridLA from '../InventoryTabs/AgreementHistory/dynamicGrids/dynamicGridLA';
import DynamicGridPA from '../InventoryTabs/AgreementHistory/dynamicGrids/dynamicGridPA';
import DynamicGridComponent from '../InventoryTabs/IdleInventoryAudit/dynamicGrid';
import { InventoryMajorContext } from '../../context/inventoryMajorContext';
import { formStyles } from '../componentstyles/formstyles';
import { RACDateTimeLabel } from '@rentacenter/racstrap';

export const ActivitiesPrintInfo = (props: any) => {
  const classes = globalStyles();
  const form = formStyles();
  const [inventoryInfo, setinventoryInfo] = useState<any>({});
  const [inventoryDetails, setinventoryDetails] = useState<any>({});
  const {t} = useTranslation('InventoryTabs');
  const{ dateTimeLocalization,countryIdentification} = useContext(InventoryMajorContext);
  const [activity, setactivity] = useState<any>({
    activity: {},
    idleAudit: {},
    agrHistory: {},
    services: {}
  });

  const sortDirection = { ASC: 'asc', DESC: 'desc' };
  useEffect(() => {
    if (props) {
      console.log('printprops', props);
      setactivity({
        ...activity,
        activity: props.activeresponse,
        idleAudit: props.idleInvAudit,
        agrHistory: props.AgrHistory,
        services: props.serviceResponse,
      });
      setinventoryInfo(props.inventoryInfoRes);
      setinventoryDetails(props.inventoryDetail);
    }
  }, [props]);

  const roundOff = (num: any, places: number) => {
    const x = Math.pow(10, places);
    return Math.round(num * x) / x;
  };

  const BindGrid = () => {
    if (
      validateObject(activity?.activity?.activities) &&
      activity?.activity?.activities?.length > 0
    ) {
      return activity.activity.activities.map((value: any, index: any) => {
        return (
          <tr key={index}>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
              {dateTimeLocalization == 1 ?(<RACDateTimeLabel
                              value={value?.activityDate}
                              displayType='ShortDate'
                              country={countryIdentification}
                              separator = '/'
                              className={`${classes.p0} ${form.formValue}`}
                             />):(value.activityDate)}
            </td>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
              {value.description == null ? '-' :t(value.description)}
            </td>
          </tr>
        );
      });
    }
  };

  const ServiceBindGrid = () => {
    if (
      activity?.services?.serviceDetails?.length > 0
    ) {
      return activity.services.serviceDetails.map((value: any, index: any) => {
        return (
          <tr key={index}>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
            {(value?.startDate ?dateTimeLocalization == 1 ?(<RACDateTimeLabel
                              value={value?.startDate}
                              displayType='ShortDate'
                              separator='/'
                              country={countryIdentification}
                              className={`${classes.p0} ${form.formValue}`}
                             />): moment(value.startDate).format('MM/DD/YYYY'):'-')}

            </td>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
            {(value?.endDate ? dateTimeLocalization == 1 ?(<RACDateTimeLabel
                              value={value?.endDate}
                              displayType='ShortDate'
                              separator='/'
                              country={countryIdentification}
                              className={`${classes.p0} ${form.formValue}`}
                             />): moment(value.endDate).format('MM/DD/YYYY'):'-')}
            </td>
                        <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
                {value?.serviceNumber ? value?.serviceNumber : '-'}
            </td>
                        <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
              
                {value?.Note ? dateTimeLocalization == 1 ?(<RACDateTimeLabel
                              value={value.startDate}
                              displayType='ShortDate'
                              separator='/'
                              country={countryIdentification}
                              className={`${classes.p0} ${form.formValue}`}
                             />): moment(value.startDate).format('MM/DD/YYYY'):'-'}
            </td>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
                {value?.vendorName ? value.vendorName:'-'}
            </td>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
                  $ {value?.serviceCost ? value?.serviceCost : '-'}
            </td>
            <td
              style={{
                border: '1px soild #000',
                padding: '5px',
                fontSize: '14px',
              }}
            >
                  {value?.serviceStatus ? value?.serviceStatus : '-'}
            </td>
          </tr>
        );
      });
    }
  };

  return (
    <div style={{ display: 'none' }}>
      {/* {inventoryInfo} */}
      <div id="InventoryPrintHTML">
        <div style={{ width: '96%', margin: '2%', float: 'left' }}>
          <div style={{ width: '100%', float: 'left', marginBottom: '6px' }}>
            <h2 style={{ float: 'left', margin: '0px' }}>
              {t('Inventory Activities')}
            </h2>
            <div
              style={{ float: 'right', marginTop: '5px', fontStyle: 'italic' }}
            >
            {t(moment().format('ddd'))+','+moment().format('D MMM YYYY, hh:mm A')}
            </div>
          </div>

          <div style={{ width: '100%', float: 'left', marginBottom: '4px' }}>
            <div style={{ width: '20%', float: 'left' }}>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {t("Rent-A-Center")}
              </span>
              <span style={{ fontSize: '14px', fontStyle: 'italic' }}>
                {' '}
                ({inventoryInfo?.inventoryHeader?.storeNumber})
              </span>
            </div>
            <div style={{ width: '30%', float: 'left' }}>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {t('Item #:')}
              </span>
              <span style={{ fontSize: '14px', fontStyle: 'italic' }}>
                {' '}
                {inventoryInfo?.inventoryHeader?.itemNumber}
              </span>
            </div>
            <div style={{ width: '50%', float: 'left' }}>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {t('Description:')}
              </span>
              <span style={{ fontSize: '14px', fontStyle: 'italic' }}>
                {' '}
                {inventoryInfo?.inventoryHeader?.description}
              </span>
            </div>
          </div>

          {/* {validateObject(inventoryInfo?.inventoryInfoRes) && inventoryInfo?.inventoryInfoRes?.inventoryInformation ? */}
          <>
            <div style={{ width: '100%', float: 'left' }}>
              <h3
                style={{
                  borderTop: '1px solid black',
                  borderBottom: '1px solid black',
                  padding: '3px',
                  marginBottom: '0px',
                }}
              >
                {t('Item Information')}
              </h3>

              <div
                style={{ width: '100%', float: 'left', marginBottom: '-12px' }}
              >
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t("Item #")}</div>
                    <div style={{ fontSize: '14px' }}>
                      {inventoryInfo?.inventoryHeader?.itemNumber
                        ? inventoryInfo?.inventoryHeader?.itemNumber
                        : '-'}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Remaining Value')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        inventoryDetails?.depreciationEstimator
                      ) &&
                      validateObject(
                        inventoryDetails?.depreciationEstimator?.remainingValue
                      ) &&
                      (inventoryDetails?.depreciationEstimator
                        ?.remainingValue !== '0' ||
                        inventoryDetails?.depreciationEstimator
                          ?.remainingValue !== '0.00') ? (
                        <NumberFormat
                          thousandsGroupStyle="thousand"
                          value={roundOff(
                            inventoryDetails?.depreciationEstimator
                              ?.remainingValue,
                            3
                          ).toFixed(2)}
                          prefix="$ "
                          className={classes.formLabelValue}
                          displayType="text"
                          type="text"
                          thousandSeparator={true}
                        />
                      ) : (
                        '$ 0.00'
                      )}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Times on Rent')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {/* {validateObject(
                        activity?.activity?.activeresponse?.reveneueAndTime
                          ?.timesOnRent
                      ) &&
                      activity?.activity?.activeresponse?.reveneueAndTime
                        ?.timesOnRent !== '0'
                        ? activity?.activity?.activeresponse?.reveneueAndTime
                            ?.timesOnRent
                        : '0'} */}
                        {validateObject(activity?.activity?.reveneueAndTime
                            ?.timesOnRent) && activity.activity.reveneueAndTime
                            .timesOnRent !=='0' ? activity.activity.reveneueAndTime
                            .timesOnRent :'0'}
                    </div>
                  </span>
                </div>
              </div>

              <div
                style={{ width: '100%', float: 'left', marginBottom: '-12px' }}
              >
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Serial Number')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        inventoryInfo?.inventoryInformation?.serialNumber
                      )
                        ? inventoryInfo?.inventoryInformation?.serialNumber
                        : '-'}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Service Expense')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        activity?.activity?.reveneueAndTime
                          ?.serviceExpense
                      ) &&
                      activity?.activity?.reveneueAndTime
                        ?.serviceExpense !== '0'
                        ? activity?.activity?.reveneueAndTime
                            ?.serviceExpense
                        : '$ 0.00'}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Times on Service')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        activity?.activity?.reveneueAndTime
                          ?.timesOnService
                      ) &&
                      activity.activity.reveneueAndTime
                        ?.timesOnService !== '0'
                        ? activity?.activity?.reveneueAndTime
                            ?.timesOnService
                        : '0'}
                    </div>
                  </span>
                </div>
              </div>

              <div
                style={{ width: '100%', float: 'left', marginBottom: '-12px' }}
              >
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Model Number')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        inventoryInfo?.inventoryInformation?.modelNumber
                      )
                        ? inventoryInfo?.inventoryInformation?.modelNumber
                        : '-'}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Revenue Collected')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {/* {validateObject(
                        activity?.activity?.activeresponse?.reveneueAndTime
                          ?.totalRevenue
                      ) &&
                      activity?.activity?.activeresponse?.reveneueAndTime
                        ?.totalRevenue !== '0'
                        ? activity?.activity?.activeresponse?.reveneueAndTime
                            ?.totalRevenue
                        : '$ 0.00'} */}
                        { validateObject(activity?.activity?.reveneueAndTime
                            ?.totalRevenue) && activity.activity.reveneueAndTime
                            .totalRevenue !== '0'?
                             '$ ' + activity?.activity?.reveneueAndTime
                            ?.totalRevenue:'$ 0.00'
                            }
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Times Transferred')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        activity?.activity?.reveneueAndTime
                          ?.timesTransferred
                      ) &&
                      activity.activity.reveneueAndTime
                        .timesTransferred !== '0'
                        ? activity?.activity?.reveneueAndTime
                            ?.timesTransferred
                        : '0'}
                      

                    </div>
                  </span>
                </div>
              </div>

              <div
                style={{ width: '100%', float: 'left', marginBottom: '-12px' }}
              >
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Purchase Date')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {(inventoryDetails?.depreciationEstimator &&
                      inventoryDetails?.depreciationEstimator?.purchaseDate
                        ? dateTimeLocalization == 1 ?(<RACDateTimeLabel
                              value={inventoryDetails?.depreciationEstimator?.purchaseDate}
                              displayType='ShortDate'
                              separator='/'
                              country={countryIdentification}
                              className={`${classes.p0} ${form.formValue}`}
                             />):  moment(
                            inventoryDetails.depreciationEstimator.purchaseDate
                          ).format('MM/DD/YYYY')
                        : '-')}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Status')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {inventoryInfo?.inventoryHeader?.status
                        ? t(inventoryInfo?.inventoryHeader?.status)
                        : '-'}
                    </div>
                  </span>
                </div>
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('MTD Revenue')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        activity?.activity?.reveneueAndTime
                          ?.mtdRevenue
                      ) &&
                      activity.activity.reveneueAndTime
                        .mtdRevenue !== '0'
                        ? activity?.activity?.reveneueAndTime
                            ?.mtdRevenue
                        : '$ 0.00'}
                    </div>
                  </span>
                </div>
              </div>

              <div
                style={{ width: '100%', float: 'left', marginBottom: '-12px' }}
              >
                <div
                  style={{
                    width: '31.3%',
                    margin: '1%',
                    float: 'left',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    <div style={{ fontSize: '14px' }}>{t('Purchase Cost')}</div>
                    <div style={{ fontSize: '14px' }}>
                      {validateObject(
                        inventoryDetails?.depreciationEstimator
                      ) &&
                      validateObject(
                        inventoryDetails?.depreciationEstimator?.purchaseCost
                      ) &&
                      (inventoryDetails?.depreciationEstimator?.purchaseCost !==
                        '0' ||
                        inventoryDetails?.depreciationEstimator
                          ?.purchaseCost !== '0.00') ? (
                        <NumberFormat
                          thousandsGroupStyle="thousand"
                          value={roundOff(
                            inventoryDetails?.depreciationEstimator
                              ?.purchaseCost,
                            3
                          ).toFixed(2)}
                          prefix="$ "
                          className={classes.formLabelValue}
                          displayType="text"
                          type="text"
                          thousandSeparator={true}
                        />
                      ) : (
                        '$ 0.00'
                      )}
                    </div>
                  </span>
                </div>
              </div>
            </div>

            {validateObject(activity?.agrHistory?.rentalAgreement) &&
            activity?.agrHistory?.rentalAgreement?.length > 0 ? (
              <div
                style={{ width: '100%', float: 'left', marginBottom: '20px' }}
              >
                <h3
                  style={{
                    borderTop: '1px solid black',
                    borderBottom: '1px solid black',
                    padding: '3px',
                  }}
                >
                  {t('Rental Agreements')}
                </h3>
                <div style={{ width: '100%', float: 'left' }}>
                  <DynamicGridRA
                    gridtype="Normal"
                    id="agreementHistorys"
                    items={activity?.agrHistory?.rentalAgreement}
                    setLoader={false}
                    isPrint={true}
                    ColumnLink={true}
                    orderBy="rentalAgreement"
                    order={sortDirection.ASC}
                  ></DynamicGridRA>
                </div>
              </div>
            ) : null}
            {validateObject(activity?.agrHistory?.promoAgreement) &&
            activity?.agrHistory?.promo?.length > 0 ? (
              <div
                style={{ width: '100%', float: 'left', marginBottom: '20px' }}
              >
                <h3
                  style={{
                    borderTop: '1px solid black',
                    borderBottom: '1px solid black',
                    padding: '3px',
                  }}
                >
                  {t('Loaner/Promos')}
                </h3>
                <div style={{ width: '100%', float: 'left',marginRight:'1%' }}>
                  <DynamicGridPA
                    gridtype="Normal"
                    id="agreementHistorys"
                    items={activity?.agrHistory?.promoAgreement}
                    setLoader={false}
                    isPrint={true}
                    ColumnLink={true}
                    orderBy="promoAgreement"
                    order={sortDirection.ASC}
                  ></DynamicGridPA>
                </div>
              </div>
            ) : null}
            {validateObject(activity?.agrHistory?.loanerAgreement) &&
            activity?.agrHistory?.loanerAgreement?.length > 0 ? (
              <div
                style={{ width: '100%', float: 'left', marginBottom: '20px' }}
              >
                <h3
                  style={{
                    borderTop: '1px solid black',
                    borderBottom: '1px solid black',
                    padding: '3px',
                  }}
                >
                  {t('Loaner Agreements')}
                </h3>
                <div style={{ width: '100%', float: 'left',marginRight:'1%' }}>
                  <DynamicGridLA
                    gridtype="Normal"
                    id="agreementHistorys"
                    items={activity?.agrHistory?.loanerAgreement}
                    setLoader={false}
                    isPrint={true}
                    ColumnLink={true}
                    orderBy="loanerAgreement"
                    order={sortDirection.ASC}
                  ></DynamicGridLA>
                </div>
              </div>
            ) : null}
            { validateObject(activity?.services) &&
             activity?.services?.serviceDetails?.length > 0 ? (
              <div
                style={{ width: '100%', float: 'left', marginBottom: '20px' }}
              >
                <h3
                  style={{
                    borderTop: '1px solid black',
                    borderBottom: '1px solid black',
                    padding: '3px',
                  }}
                >
                  {t('Services')}
                </h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Begin Date')}{' '}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('End Date')}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Service #')}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                     {t('Notes')}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Vendor')}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Cost')}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Status')}
                    </th>
                  </tr>
                </thead>
                <tbody>{ServiceBindGrid()}</tbody>
              </table>
              </div>
            ) : null}
            {validateObject(activity?.idleAudit?.inventoryAuditInfo) &&
            activity?.idleAudit?.inventoryAuditInfo?.length > 0 ? (
              <div
                style={{ width: '100%', float: 'left', marginBottom: '20px' }}
              >
                <h3
                  style={{
                    borderTop: '1px solid black',
                    borderBottom: '1px solid black',
                    padding: '3px',
                  }}
                >
                  {t('Idle Inventory Audits')}
                </h3>
                <div style={{ width: '100%', float: 'left',marginRight:'1%' }}>
                  <DynamicGridComponent
                    gridtype="Normal"
                    id="packagePriceItems"
                    setLoader={false}
                    items={activity?.idleAudit?.inventoryAuditInfo}
                    isPrint={true}
                    ColumnLink={true}
                    orderBy="loanerAgreement"
                    order={sortDirection.ASC}
                  ></DynamicGridComponent>
                </div>
              </div>
            ) : null}
            <div style={{ width: '100%', float: 'left', marginBottom: '20px' }}>
              <h3
                style={{
                  borderTop: '1px solid black',
                  borderBottom: '1px solid black',
                  padding: '3px',
                }}
              >
                {t('Activity')}
              </h3>
              <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Date')}{' '}
                    </th>
                    <th
                      style={{
                        border: '1px solid #000',
                        backgroundColor: '#ccc',
                        padding: '5px',
                        fontSize: '14px',
                        textAlign:'left'
                      }}
                    >
                      {t('Description')}
                    </th>
                  </tr>
                </thead>
                <tbody>{BindGrid()}</tbody>
              </table>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};
export default ActivitiesPrintInfo;
